module.exports = __webpack_public_path__ + "img/1.1cee744d.png";